export default __webpack_public_path__ + "static/media/device_not_supported_mobile.8ed2333c.png";